<div
  class="flex min-h-[56px] w-72 flex-col rounded-md border-2 p-2"
  [ngClass]="{
    'border-solid border-slate-100 bg-white': !isTemporary(),
    'bg-primary-50 border-primary-100 border-dashed': isTemporary(),
    '!border-primary-500': filter().isPlaceholder
  }"
>
  @if (summary(); as summary) {
    <div class="flex flex-row items-start gap-1">
      <div class="flex grow text-xs opacity-50">
        {{ summary.label }} {{ summary.comparison }}
      </div>

      @if (isTemporary()) {
        <div class="text-primary-200 text-xs italic">temporary</div>
      }
      <ng-content />
    </div>
    <div>
      @if (filter().placeholderMessage; as placeholderMessage) {
        <div
          class="text-primary-500 w-fit max-w-full"
          matTooltipPosition="below"
          [matTooltip]="placeholderMessage"
        >
          Select a value before running the report
        </div>
      } @else {
        <div
          class="w-fit max-w-full truncate"
          matTooltipPosition="below"
          [matTooltip]="summary.value"
        >
          {{ summary.value }}
        </div>
      }
    </div>
  }
</div>
